module.exports = __webpack_public_path__ + "static/media/binance.1fc03146.png";